import { useTranslation } from "react-i18next";
import WarningIcon from "../../../assets/images/icons/Warningicon.svg";
import WarningcloseIcon from "../../../assets/images/icons/close.svg";

const LoadingProcessModal = ({ onClose }) => {
    const { t } = useTranslation();

    return (
        <div
            className="modal"
            style={{ display: "block", backgroundColor: "rgba(217, 217, 217, 0.59)" }}
            id="dateModal"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="dateModalLabel"
            aria-hidden="true"
        >
            <div className="modal fade show alertpopup d-block">
                <div className="modal-dialog modal-dialog-centered modal-custom-width">
                    <div className="modal-content modal-radius">
                        <div className="modal-body">
                            <div className="d-flex justify-content-between align-items-center mb-4">
                                <h5 className="popup-title">{t("warning")}</h5>
                                <div className="close-modal">
                                    <a onClick={onClose}>
                                        <img src={WarningcloseIcon} aria-label="Close" />
                                    </a>
                                </div>
                            </div>
                            <div className="modal-des mt-35">
                                <p>{t("calender_request_pending_will_processed")}</p>
                                <div className="modal-img text-center">
                                    <img className="warning-icon" src={WarningIcon} alt="Warning Icon" />
                                </div>

                                <div className="d-flex justify-content-end gap-3 mt-4">
                                    <button
                                        type="button"
                                        className="main-btn outline-alert-btn w-full"
                                        onClick={onClose}
                                    >
                                        {t("confirm")}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoadingProcessModal;
